import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';

export function generateDropdownFormField(
  params: FormFieldGenerationParams<'dropdown'>,
): PartialPropsOf<'dropdown'> {
  const props: PartialPropsOf<'dropdown'> = applyPropsPatch(params.props, {
    style: { general: { offset: { margin: '$t.spacingFormField' } } },
  });

  return props;
}
